'use client';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ROUTES } from '@/utils/constants';

const NotFound = () => {
  const router = useRouter();
  
  useEffect(() => {
    router.push(ROUTES.SIGNIN);
  }, [router]);
  
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
      <p className="mb-4">Redirecting to sign in page...</p>
    </div>
  );
};

export default NotFound;
